/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-09T17:00:10.602
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairFeedbackHouseElectric,
	listRentRepairFeedbackHouseElectricInit,
	listRentRepairFeedbackHouseElectricByAuthorizations,
	deleteRentRepairFeedbackHouseElectric
} from '@api/rentmanage/RentRepairFeedbackHouseElectric';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairFeedbackHouseElectric({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackHouseElectric(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackHouseElectricByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackHouseElectricByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackHouseElectricInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackHouseElectricInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedbackHouseElectric({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedbackHouseElectric({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
